import React from 'react'
import './index.scss'

function index() {
  return (
    <div className='resume-container'>
        <iframe src="https://drive.google.com/file/d/1Z9h_08mvLESxW_7tMK_ysP-tagYMklRy/preview" width="880" height="880px" className='resume'></iframe>
    </div>
  )
}

export default index